import { caseTypeArray, netWorthDropdown } from "Components/Client/Cases/CaseFormFields";
import { PROFACCOUNTFIELDS, numberToString, ADMIN, PROFESSIONAL, FIRM } from "Constants";

// Where a notification's "See more"/click-through should navigate to.
// Pulled out of NotificationListItem so the header bell dropdown can reuse
// the exact same routing logic instead of re-deriving it.
export const getNotificationSeeMoreLink = (msg, role) => {
    const isPro = role === PROFESSIONAL || role === FIRM;
    // attorneys / law firms: a case notification opens that case's page
    if(isPro && msg?.additionalInfo?.caseId)
    {
        return "/attorney/caseDetails/" + msg.additionalInfo.caseId;
    }
    if(msg?.additionalInfo?.url)
    {
        // older notifications saved "/casesFeed/..." without the /attorney prefix
        const url = msg.additionalInfo.url;
        return url.startsWith("/casesFeed") ? "/attorney" + url : url;
    }
    else if(msg?.type === "1" || msg?.type === "2")
    {
        if(role === ADMIN) //admin
        {
            if(msg?.additionalInfo)
            {
               return "/admin/approve"
            }
            else
            {
               return "/admin/approve";
            }
        }
        else
        {
            if(isPro)
            {
                return "/attorney/approve";
            }
            else
           {
               return "/client/profile"
           }
        }
    }
    //case related notifications
    else if(msg?.type === "2" || msg?.type === "3" || msg?.type === "4")
    {
        if(!isPro && msg?.additionalInfo?.caseId)
        {
           return "/client/caseDetails/" + msg.additionalInfo.caseId;
        }
    }
}


export const downloadTableCSV = (id, fileName, columnPref) => {
    const table = document.getElementById(id);
    const rows = table.querySelectorAll('tr');
    let csvContent = '';

    rows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll('td, th').forEach((cell) => {
            console.log(row);
            rowData.push(cell.innerText);
        });
        csvContent += rowData.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', fileName+'.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}
export const getNoOfTimesRequested = (array, id) => {
    if(array && array.length !== 0 )
    {
 return array.filter(function(x){return x === id}).length

    }
    else
    return null;
}
export const getStringFromNumber = (num) => {
    return numberToString[num];
}
export const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }
  export const processReqReviewCount = (data, userInfo) => {
        let idWithReqReviewArr = null;
        if(data?.length !== 0 )
            {
                idWithReqReviewArr = {}
                data?.map((item) => {
                       // let incrCounter = item.deniedCount !== 0 ? (item.caseStatus === "denied" ? item.deniedCount : parseInt(item.deniedCount) + 1 ) : 1;
                      let incrCounter =  1 ;
                       let statusVariable =  (item.caseStatus === "denied" && item.userId !== userInfo._id) ? "requested" : item.caseStatus;
                        if(idWithReqReviewArr[item.caseId])
                        {   
                            if(idWithReqReviewArr[item.caseId][statusVariable])
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : idWithReqReviewArr[item.caseId][statusVariable] + incrCounter; 
                            }
                            else
                            {
                                idWithReqReviewArr[item.caseId][statusVariable] = item.caseStatus === "denied" ? item.deniedCount : incrCounter;
                            }
                        }
                        else
                        {
                            
                            idWithReqReviewArr[item.caseId] = { [statusVariable] : item.caseStatus === "denied" ? item.deniedCount : incrCounter}
                        }
                        
                })  
            }

                console.log(idWithReqReviewArr)
                return idWithReqReviewArr;

    }
export const validateEmail = (email) => {
    // var blockedDomains = ['gmail.com','yahoo.com','icloud.com', 'protonmail.com', 'gmx.com', 'ymail.com', 'outlook.com', 'aol.com', 'live.com', 'gmx.de', 'hotmail.com', 'hotmail.com.uk'];

    // var domain = email.split('@')[1];

    // if (blockedDomains.includes(domain)) {
    //     return false;
    // } else {
    //     return true;
    // }
    return true;
}
export const getUserLocationFromIP = async () => {
    try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        const { city, region, country } = data;
        return `${city}, ${region}, ${country}`;
    }
    catch (error) {
        console.error('Error fetching location from IP:', error);
        return null;
    }
}

export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by this browser.');
      return reject('Geolocation not supported');
    }
    try {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
          );
          const data = await response.json();
          const address = data.address;

          const locationString = `${address.city || address.town || address.village || ''}, ${address.state}, ${address.country}`;
          resolve(locationString);
        } catch (err) {
          console.error('Error fetching location details:', err);
          resolve(err);
        }
      },
      (error) => {
        console.error('Error getting geolocation:', error);

        resolve(error);
      }
    );
    }
    catch (error) {
        console.error('Error:', error);
        resolve(error);
      }
  });
};
export const checkIfCaseValuable = (formValues) => {
  // (a) any case that is a product liability case, (b) any case that is a class action case, and (c) any case that is against a public company.
  console.log("Checking if case is valuable:", formValues);
  if (formValues.caseType === 'liability' || formValues.isClassAction === 'yes' || formValues.adversePartyPublicCompany === 'yes') {
    return true;
  }
  else
  {
    return false;

  }
}
export const getCaseType = (type) => {
    let name = '';
    caseTypeArray.map((ele) => {
        if(ele.id === type)
        {
            name =  ele.name;
        }
    });
    return name;
}
export const isToday = (dateString) => {
  const givenDate = new Date(dateString);
  const today = new Date();

  return (
    givenDate.getDate() === today.getDate() &&
    givenDate.getMonth() === today.getMonth() &&
    givenDate.getFullYear() === today.getFullYear()
  );
}
export const getNetWorth = (value) => {
let returnVal = ''
    netWorthDropdown.map((ele) => {

        if(parseInt(ele.id) === parseInt(value))
        {
            returnVal = ele.name;
        }
    });
     return returnVal;
}
export const isDateExpired = (inputDate) =>{
  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize time to midnight
  const givenDate = new Date(inputDate);
  givenDate.setHours(0, 0, 0, 0); // normalize time to midnight

  return givenDate < today;
}
export const getArrValue = (arr, value, label, returnVal) => {
    
    let name = '';
    arr.map((ele) => {
        if(ele[label] === value)
        {
            name = ele[returnVal]
        }
        return name;
    }
    );
    return name;
}
export const getLabelProfAccount = (field) => {
    let fieldName = field;
    Object.entries(PROFACCOUNTFIELDS).map(([label, value]) => {
        if(value === field)
        {
            fieldName = label;
        }
    });
    return fieldName;
}

// Translates raw Cognito / API error messages into plain-language text a user can act on.
// Cognito (and sometimes our own API) surfaces raw validation internals - e.g. the password
// policy's regular expression pattern - straight through to the UI, which is meaningless to a
// user. This maps known error shapes to a friendly message and otherwise falls back to a safe
// generic message instead of ever showing raw exception/regex text.
export const getFriendlyAuthErrorMessage = (error) => {
    const raw =
        (typeof error === "string" ? error : null) ||
        error?.response?.data?.message ||
        error?.message ||
        "";

    const message = String(raw || "").trim();
    const lower = message.toLowerCase();

    if(lower.includes("regular expression pattern") || lower.includes("failed to satisfy constraint"))
    {
        return "Your password isn't in a valid format. It can't start or end with a space, and needs to be at least 8 characters long.";
    }
    if(lower.includes("incorrect username or password") || lower.includes("notauthorizedexception"))
    {
        return "Incorrect email or password. Please try again.";
    }
    if(lower.includes("user does not exist") || lower.includes("usernotfoundexception"))
    {
        return "We couldn't find an account with that email.";
    }
    if(lower.includes("usernameexistsexception") || lower.includes("already exists"))
    {
        return "An account with this email already exists. Try signing in instead.";
    }
    if(lower.includes("invalidpasswordexception") || lower.includes("password did not conform"))
    {
        return "Your password doesn't meet the requirements. Use at least 8 characters, with a mix of letters, numbers, and symbols.";
    }
    if(lower.includes("codemismatchexception") || lower.includes("invalid verification code"))
    {
        return "That verification code isn't correct. Please check and try again.";
    }
    if(lower.includes("expired") && lower.includes("code"))
    {
        return "That verification code has expired. Please request a new one.";
    }
    if(lower.includes("limitexceededexception") || lower.includes("too many"))
    {
        return "Too many attempts. Please wait a moment and try again.";
    }
    if(lower.includes("network") || lower.includes("timeout") || lower.includes("failed to fetch"))
    {
        return "We couldn't reach the server. Please check your connection and try again.";
    }
    if(!message || lower.includes("validation error") || lower.includes("constraint"))
    {
        return "Something went wrong. Please check your details and try again.";
    }

    // Anything short, plain-sentence-shaped, and free of code-ish punctuation is probably
    // already a user-facing message (e.g. one of our own backend messages) - show it as-is.
    if(message.length < 160 && !lower.includes("exception") && !/[{}<>]/.test(message))
    {
        return message;
    }

    return "Something went wrong. Please try again.";
}
